import React, { useState, useEffect } from "react";
import { GoTrash } from "react-icons/go";
import { BsDownload } from "react-icons/bs";
import { useDropzone } from "react-dropzone";

export const ProductFiles = ({ data, setData }) => {
  const [files, setFiles] = useState(data.productFiles || []);

  // Update parent component with the latest files
  useEffect(() => {
    setData(prevData => ({ ...prevData, productFiles: files }));
  }, [files, setData]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: '.zip',
    maxSize: 150 * 1024 * 1024, // Limit to 150 MB
    onDrop: (acceptedFiles) => {
      setFiles(prevFiles => [
        ...prevFiles,
        ...acceptedFiles.map(file => ({
          name: file.name,
          size: file.size,
          preview: URL.createObjectURL(file),
          file // Store the file object for downloading
        }))
      ]);
    },
    onDropRejected: (rejectedFiles) => {
      alert(`Some files were rejected: ${rejectedFiles.map(file => file.errors.map(e => e.message).join(', ')).join(' | ')}`);
    }
  });

  const removeFile = (index) => {
    // Revoke the object URL to free up memory
    URL.revokeObjectURL(files[index].preview);
    setFiles(files.filter((_, i) => i !== index));
  };

  return (
    <div className="bg-[#F0F0F0] dark:bg-[#282828] p-4 rounded my-4">
      <div className="flex items-center space-x-2">
        <div className="bg-[#CCC9FF] w-4 h-4 rounded" />
        <h1>Product Files</h1>
      </div>
      {/* part one: upload area */}
      {files.length === 0 ? (
        <div
          {...getRootProps({ className: "border-[1px] border-dashed text-center p-4 rounded-lg my-4 border-gray-600" })}
        >
          <input {...getInputProps()} />
          <p>
            Attach .zip archive(s) containing only files for sale. Max 150 MB.
          </p>
          <div className="relative flex justify-center items-center space-x-8 my-4">
            <button className="bg-white cursor-pointer text-black px-4 py-2 rounded ">
              Upload or Drop Files
            </button>
          </div>
        </div>
      ) : (
        <>
          {/* part two: file list */}
          {files.map((file, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-4 rounded-lg my-4 border dark:border-[#5B5B5B]"
            >
              <div>
                <p>{file.name}</p>
                <p className="opacity-60">({(file.size / (1024 * 1024)).toFixed(1)} MB)</p>
              </div>
              <div className="flex items-center space-x-2">
                <a
                  href={file.preview}
                  download={file.name}
                  className="border p-2 rounded-lg space-x-2 flex items-center"
                >
                  <BsDownload className="hidden md:block" />
                  <p>Download</p>
                </a>
                <div
                  onClick={() => removeFile(index)}
                  className="border text-[#F08383] border-[#F08383] space-x-2 flex items-center shrink-0 py-3 px-3 rounded-lg cursor-pointer"
                >
                  <GoTrash />
                </div>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};
